"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Connector = /** @class */ (function () {
    function Connector(segments) {
        if (segments.length == 0) {
            throw new Error("Need at least one segment");
        }
        this.Segments = segments;
    }
    return Connector;
}());
exports.default = Connector;
